export default "__VITE_ASSET__NF2v_wQm__"